import { useMemo } from "react";
import { ListFormatter, TextFormatter } from "../muiTableHelper";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { createConfirm } from "../../confirm";
import { createToast } from "../../toast";
import { _ACTIONS, _ROLES, _ROLES_BACK, _SWAL_ICONS } from "../../constants";
import { RequestHelper } from "../../requestHelper";
import { _ROUTES } from "../../_routes_constants";
import _ from "lodash";

export const UsersListColumns = ({
  setEditData,
  setShowModal,
  user,
  setRefresh,
}) => {
  const getRolesLabels = (roles) => {
    if (_.isEmpty(roles)) return [];
    return roles
      .map((role) => {
        const foundRole = _ROLES.find(
          (r) => r.value === role && role !== _ROLES_BACK._ROLE_USER
        );
        return foundRole ? foundRole.label : undefined;
      })
      .filter(Boolean);
  };

  return useMemo(
    () => [
      {
        accessorKey: "email",
        header: "Mail",
        Cell: ({ row }) => {
          return TextFormatter({ text: row.original.email });
        },
      },
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.lastName + " " + row.original.firstName,
          });
        },
      },

      {
        accessorKey: "role",
        header: "Role",
        Cell: ({ row }) => {
          return ListFormatter(getRolesLabels(row.original.roles));
        },
      },
      {
        accessorKey: "actions",
        header: "Actions",
        Cell: ({ row }) => {
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setEditData(row.original);
                  setShowModal(true);
                }}>
                <EditIcon />
              </IconButton>
              <IconButton
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (row.original.email !== user.email) {
                    createConfirm("Are you sure you want to delete this user?")
                      .fire({})
                      .then((result) => {
                        if (result.isConfirmed) {
                          // Processing
                          const rq = new RequestHelper();

                          rq.doRequest(
                            _ACTIONS.DELETE,
                            _ROUTES.USERS + "/" + row.original.id
                          ).then((res) => {
                            console.log(res);
                            if (res.status === 204) {
                              createToast(
                                _SWAL_ICONS.success,
                                "The user has been deleted"
                              ).then(() => {
                                setRefresh((prev) => prev + 1);
                              });
                            } else {
                              createToast(_SWAL_ICONS.error, "An error occurred");
                            }
                          });
                        }
                      });
                  } else {
                    createToast(
                      _SWAL_ICONS.error,
                      "You cannot delete your own account"
                    );
                  }
                }}>
                <DeleteForeverIcon />
              </IconButton>
            </>
          );
        },
      },
    ],
    [setEditData, setShowModal, user, setRefresh]
  ); // Add columns here
};
